module.exports = __webpack_public_path__ + "resources/6446750bbbbad3ea386ac1c4ef0cc478.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove1.png
// module id = 195
// module chunks = 0